import { forwardRef } from 'react';
import { TextInput as TextInputBase } from '@jagad/ui';
import type { TextInputProps as TextInputBaseProps } from '@jagad/ui';
import { useTranslation } from 'react-i18next';

type TextInputProps = Omit<TextInputBaseProps, 'defaultTitle' | 'optionalLabel' | 'defaultErrorText' | 'defaultPlaceholder'> & {
    defaultTitle?: string;
    optionalLabel?: string;
    defaultErrorText?: string;
    defaultPlaceholder?: string;
};

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(({
    defaultTitle,
    optionalLabel,
    defaultErrorText,
    defaultPlaceholder,
    ...props
}, ref) => {
    const { t } = useTranslation();
    return (
        <TextInputBase
            {...props}
            ref={ref}
            defaultTitle={defaultTitle ?? t('components.textInput.defaultTitle')}
            optionalLabel={optionalLabel ?? t('components.textInput.optional')}
            defaultErrorText={defaultErrorText ?? t('components.textInput.defaultErrorText')}
            defaultPlaceholder={defaultPlaceholder ?? t('components.textInput.defaultPlaceholder')}
        />
    );
});

export default TextInput;
